import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DelayCircle from './delay-circle.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DelayCircle {...validProps} />;
}
SvgComponent.iconName = 'delay-circle';

export const DelayCircleIcon = svgIconWrapper(SvgComponent);
